<template>
  <v-container>
    <v-row class="justify-center d-flex mt-n16">
      <v-col lg="4" md="7" class="mx-auto">
        <v-card class="card-shadow border-radius-xl">
          <div class="card-padding text-center">
            <h5 class="text-h5 text-typo font-weight-bold">Reset your password</h5>
            <p class="text-sm text-body mt-2 mb-0">
              {{ codeSent
                ? 'Enter the code we emailed you and choose a new password.'
                : 'Enter your email and we will send you a reset code.' }}
            </p>
          </div>
          <div class="card-padding">
            <v-text-field
              v-model="email"
              :disabled="codeSent"
              hide-details
              outlined
              background-color="rgba(255,255,255,.9)"
              color="rgba(0,0,0,.6)"
              light
              height="40"
              placeholder="Email"
              @keyup.enter="submit()"
              :class="inputClass"
            >
            </v-text-field>

            <template v-if="codeSent">
              <v-text-field
                v-model="code"
                hide-details
                outlined
                background-color="rgba(255,255,255,.9)"
                color="rgba(0,0,0,.6)"
                light
                height="40"
                placeholder="Reset code"
                autocomplete="one-time-code"
                :class="inputClass"
              >
              </v-text-field>
              <v-text-field
                v-model="newPassword"
                type="password"
                hide-details
                outlined
                background-color="rgba(255,255,255,.9)"
                color="rgba(0,0,0,.6)"
                light
                height="40"
                placeholder="New password"
                autocomplete="new-password"
                @keyup.enter="submit()"
                :class="inputClass"
              >
              </v-text-field>
            </template>

            <p v-if="errorMessage" class="text-sm text-danger mb-0">{{ errorMessage }}</p>

            <v-btn
              @click.prevent="submit()"
              :loading="loading"
              elevation="0"
              :ripple="false"
              height="43"
              class="font-weight-bold text-uppercase btn-default bg-gradient-default py-2 px-6 me-2 mt-6 mb-2 w-100"
              color="#5e72e4"
              small
              >{{ codeSent ? 'Set New Password' : 'Send Reset Code' }}</v-btn
            >
            <p v-if="codeSent" class="text-sm text-body mt-3 mb-0">
              Didn't get it?
              <a
                @click.prevent="sendCode()"
                class="ml-2 text-dark text-decoration-none font-weight-bolder"
                >Send a new code</a
              >
            </p>
            <p class="text-sm text-body mt-1 mb-0">
              <a
                @click.prevent="$router.push({ path: '/pages/authentication/login' })"
                class="text-dark text-decoration-none font-weight-bolder"
                >Back to log in</a
              >
            </p>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { forgotPassword, confirmForgotPassword, authErrorMessage } from '@/auth/cognito'

export default {
  name: "forgot-password",
  data() {
    return {
      email: this.$route.query.email || '',
      code: '',
      newPassword: '',
      codeSent: false,
      loading: false,
      errorMessage: '',
      inputClass: 'input-style font-size-input border border-radius-md placeholder-lighter text-color-light mb-4',
    };
  },
  methods: {
    submit() {
      return this.codeSent ? this.resetPassword() : this.sendCode()
    },
    async sendCode() {
      if (this.loading) return
      this.errorMessage = ''
      this.loading = true
      try {
        await forgotPassword(this.email)
        this.codeSent = true
      } catch (error) {
        this.consoleLog('error', 'ForgotPassword.vue fn(sendCode): error catch', error)
        this.errorMessage = authErrorMessage(error)
      } finally {
        this.loading = false
      }
    },
    async resetPassword() {
      if (this.loading) return
      this.errorMessage = ''
      this.loading = true
      try {
        await confirmForgotPassword(this.email, this.code, this.newPassword)
        await this.$swal({ icon: 'success', title: 'Password updated', text: 'You can now log in with your new password.' })
        this.$router.push({ path: '/pages/authentication/login' })
      } catch (error) {
        this.consoleLog('error', 'ForgotPassword.vue fn(resetPassword): error catch', error)
        this.errorMessage = authErrorMessage(error)
      } finally {
        this.loading = false
      }
    },
  },
};
</script>
